import { apiRequest } from "./apiClient";

const parseJsonValue = (value: any) => {
  if (typeof value !== "string") return value;
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};

const normalizeCostModelResponse = (response: any) => {
  const parsedResponse = parseJsonValue(response);
  const responseData = parseJsonValue(parsedResponse?.data);
  const dataOutput = parseJsonValue(responseData?.output);
  const rootOutput = parseJsonValue(parsedResponse?.output);
  const outputRows = [
    dataOutput?.foreach,
    dataOutput?.data,
    dataOutput,
    rootOutput?.foreach,
    rootOutput?.data,
    rootOutput,
    responseData?.foreach,
    responseData,
    parsedResponse?.foreach,
  ].find((candidate) => Array.isArray(candidate) && candidate.length > 0);

  if (!outputRows) return null;

  const data =
    responseData && typeof responseData === "object" && !Array.isArray(responseData)
      ? responseData
      : {};
  const output =
    dataOutput && typeof dataOutput === "object" && !Array.isArray(dataOutput)
      ? dataOutput
      : rootOutput && typeof rootOutput === "object" && !Array.isArray(rootOutput)
        ? rootOutput
        : {};

  return {
    ...parsedResponse,
    data: {
      ...data,
      output: {
        ...output,
        foreach: outputRows,
      },
    },
  };
};

export async function runSequentialCostModelBatches<T>(
  batches: T[],
  runBatch: (batch: T) => Promise<any>
) {
  const results = [];
  for (const batch of batches) {
    const result = normalizeCostModelResponse(await runBatch(batch));
    if (!result) {
      throw new Error("Invalid Cost Model response: a batch returned no output.");
    }
    results.push(result);
  }
  return results;
}

export async function getOrGenerateCostModelWorkflow(
  inputData: unknown[],
  generate: () => Promise<any>
) {
  const records = await apiRequest("/api/cost-model-workflow?is_standalone=false");
  const cached = records[0];
  if (cached) {
    const normalizedCachedOutput = normalizeCostModelResponse(cached.output_data);
    if (!normalizedCachedOutput) {
      throw new Error("Saved workflow record has no cost model output. Agent was not called.");
    }
    return { result: normalizedCachedOutput, fromCache: true };
  }

  const result = normalizeCostModelResponse(await generate());
  if (!result) {
    throw new Error("Invalid Cost Model response: no cost model output found.");
  }
  await apiRequest("/api/cost-model-workflow", {
    method: "POST",
    body: JSON.stringify({
      request_id: result.trace_id || null,
      input_data: inputData,
      output_data: result,
      model_name: "SimplAI-Tool52",
      processing_status: "SUCCESS",
      agent_type: "cost_model_workflow",
      is_standalone: false,
    }),
  });
  return { result, fromCache: false };
}